/**
 * Calculate and clamp buying power usage fraction to [0, 1] range.
 * Handles NaN, Infinity, and boundary cases gracefully.
 * @param used - Used buying power amount
 * @param total - Total buying power amount
 * @returns Clamped fraction in range [0, 1], or 0 if calculation is invalid
 */
export function clampBpFraction(used: number, total: number): number {
  const fraction = used / total

  if (Number.isFinite(fraction)) {
    return Math.min(Math.max(fraction, 0), 1)
  }

  return 0
}
